import { render } from "./Diagnostics.vue?vue&type=template&id=6c825d78"
import script from "./Diagnostics.vue?vue&type=script&lang=js"
export * from "./Diagnostics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__